module.exports = __webpack_public_path__ + "static/media/new-balance.6ac8b72d.jpg";